const newLocal = {
    dateOfIEP:'IEP date',
    year:'Year',
    numberOfGoals:'Goals',
    numberOfObjectives:'Objectives',
    numberOfObjectivesAchieved:'Completed Objectives'

};
export default newLocal;
